const actionTypes = {
  SELECT_FUNCTION: "SELECT_FUNCTION",
  ADD_ITEM: "ADD_ITEM",
  REMOVE_ITEM: "REMOVE_ITEM",
  UPDATE_ITEM_QUANTITY: "UPDATE_ITEM_QUANTITY",
  UPDATE_ITEM_GROUPS: "UPDATE_ITEM_GROUPS",
  SET_STEP: "SET_STEP",
  RESET: "RESET"
} as const;

export default actionTypes;
